// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1B_Bp","placeholdersHeader":"styles_placeholdersHeader__2LLOD","editorStyle":"styles_editorStyle__yfL27","placeholdersBox":"styles_placeholdersBox__1tdlK"};